import gql from 'graphql-tag'

const ADD_PROJECT_ASSET = gql`
  mutation addProjectAsset(
    $tenantId: Int!
    $projectId: Int!
    $projectAssetTypeId: Int!
    $assetCount: Int!
  ) {
    addProjectAsset(
      tenantId: $tenantId
      projectId: $projectId
      projectAssetTypeId: $projectAssetTypeId
      assetCount: $assetCount
    ) {
      id
      projectId
      projectAssetTypeId
      assetCount
    }
  }
`
const UPDATE_PROJECT_ASSET = gql`
  mutation updateProjectAsset(
    $tenantId: Int!
    $id: Int!
    $projectId: Int!
    $projectAssetTypeId: Int!
    $assetCount: Int!
  ) {
    updateProjectAsset(
      tenantId: $tenantId
      id: $id
      projectId: $projectId
      projectAssetTypeId: $projectAssetTypeId
      assetCount: $assetCount
    ) {
      id
      projectId
      projectAssetTypeId
      assetCount
    }
  }
`

const DELETE_PROJECT_ASSET = gql`
  mutation deleteProjectAsset($tenantId: Int!, $id: Int!) {
    deleteProjectAsset(tenantId: $tenantId, id: $id) {
      success
      data
      error
    }
  }
`

export {
  ADD_PROJECT_ASSET,
  UPDATE_PROJECT_ASSET,
  DELETE_PROJECT_ASSET,
}